import React, { useState } from 'react';
import site from '../content/siteContent';

export default function Hero() {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    location: site.address.city + ', ' + site.address.region,
    work: site.work,
  });
  const [sent, setSent] = useState(false);

  function handleChange(e) {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    // Placeholder submit: replace with real endpoint (Formspree or backend)
    console.log('Lead', form);
    setSent(true);
    setForm({
      name: '',
      phone: '',
      location: site.address.city + ', ' + site.address.region,
      work: site.work,
    });
    setTimeout(() => setSent(false), 4000);
  }

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <picture>
          <source
            srcSet={`${site.projects[0].img.replace('/1200x900.jpg', '-2000x1500.webp')} 1x`}
            type="image/webp"
          />
          <img
            src={site.projects[0].img}
            alt="Hero background"
            className="w-full h-full object-cover"
          />
        </picture>
        <div
          className="absolute inset-0 hero-overlay"
          style={{
            background: 'linear-gradient(180deg, rgba(0,0,0,0.45), rgba(0,0,0,0.5))',
          }}
        ></div>
      </div>

      <div className="container relative z-10 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {/* spacer column: appears before content on md to reserve left column (hidden on mobile) */}
          <div className="hidden md:block md:order-1" aria-hidden="true"></div>

          {/* hero content: visible on mobile first, placed in right column on md+ */}
          <div className="max-w-xl order-1 md:order-2">
            <div className="hero-content backdrop-blur-md bg-white/4 border border-white/4 p-6 md:p-8 rounded">
              <div className="text-sm uppercase tracking-wide text-muted">Bespoke Interiors</div>
              <h1 className="hero-headline font-extrabold text-3xl md:text-4xl">
                Premium interiors, crafted.
              </h1>
              <p className="mt-3 mb-4 text-surface/95">
                Precision joinery and considered design for lasting interiors.
              </p>

              <div className="flex flex-wrap gap-3 items-center">
                <a href="/contact" className="btn btn-wood" aria-label="Book a visit">
                  Book a Visit
                </a>
                <a href="/portfolio" className="btn btn-ghost-outline">
                  View Portfolio
                </a>
              </div>

              {sent && (
                <div role="status" className="mt-4 text-sm text-wood-dark">
                  Thanks — we will call you soon.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
